import { BrowserConsumerHistory } from './browser-consumer-history';
import { createHistoryV4Adapter } from './create-history-v4-adapter';
import { StaticConsumerHistory } from './static-consumer-history';
export function createHistoryServiceV1Binder(context, historyMultiplexers, options) {
    const { getHistoryKey } = options;
    return (consumerId, consumerName) => {
        const historyKey = getHistoryKey({ consumerId, consumerName });
        let browserConsumerHistoryDestroy = () => undefined;
        let browserConsumerHistory;
        let staticConsumerHistory;
        const featureService = {
            createBrowserHistory: () => {
                if (browserConsumerHistory) {
                    context.logger.warn(`createBrowserHistory was called multiple times by consumer ${JSON.stringify(consumerId)}. Returning the same history instance as before.`);
                }
                else {
                    const browserConsumerHistoryV5 = new BrowserConsumerHistory(context, historyKey, historyMultiplexers.browserHistoryMultiplexer);
                    browserConsumerHistoryDestroy = () => browserConsumerHistoryV5.destroy();
                    browserConsumerHistory = createHistoryV4Adapter(context, browserConsumerHistoryV5);
                }
                return browserConsumerHistory;
            },
            createStaticHistory: () => {
                if (staticConsumerHistory) {
                    context.logger.warn(`createStaticHistory was called multiple times by consumer ${JSON.stringify(consumerId)}. Returning the same history instance as before.`);
                }
                else {
                    staticConsumerHistory = createHistoryV4Adapter(context, new StaticConsumerHistory(context, historyKey, historyMultiplexers.staticHistoryMultiplexer));
                }
                return staticConsumerHistory;
            },
            get staticRootLocation() {
                return historyMultiplexers.staticHistoryMultiplexer.rootLocation;
            },
        };
        const unbind = () => {
            browserConsumerHistoryDestroy();
        };
        return { featureService, unbind };
    };
}
//# sourceMappingURL=create-history-service-v1-binder.js.map